import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import * as React from 'react';

import { UitkDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkHeading } from 'uitk-react-text';
import { UitkLoader } from 'uitk-react-loader';

export interface FlexDocumentDialogProps {
  url: string;
  headerText: string;
}

export const FlexDocumentDialog: React.FunctionComponent<FlexDocumentDialogProps> = ({ url, headerText }) => {
  return (
    <DialogRoute id="flex-document-dialog">
      <Layer id="dialog">
        <UitkDialog dialogShow={true} className="FlexDocument__dialog">
          <UitkDialogContent key="flexDialogContent1" className="FlexDocumentContent__dialog">
            <UitkHeading tag="h2" size={3}>
              {headerText}
            </UitkHeading>
            <div data-stid="flex-doc-frame">
              {url === undefined ? (
                <UitkLoader className="FlexDocument__spinner" />
              ) : (
                <iframe src={url} role="article" />
              )}
            </div>
          </UitkDialogContent>
        </UitkDialog>
      </Layer>
    </DialogRoute>
  );
};
